import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';

import { EuiChipListComponent, EuiChipListAppendContentDirective } from './eui-chip-list.component';
import { EuiChipModule } from '../eui-chip/eui-chip.module';
import { EuiButtonModule } from '../eui-button/eui-button.component';
import { EuiIconModule } from '../atoms';
import { EuiLabelModule } from '../atoms/eui-label/eui-label.module';
import { EuiChipListDragService } from './services/eui-chip-list-drag.service';
import { EuiTruncatePipeModule } from '../../pipes/eui-truncate.pipe';

@NgModule({
    imports: [
        CommonModule,
        EuiChipModule,
        EuiButtonModule,
        EuiIconModule,
        EuiLabelModule,
        MatChipsModule,
        DragDropModule,
        TranslateModule,
        EuiTruncatePipeModule,
    ],
    declarations: [
        EuiChipListComponent,
        EuiChipListAppendContentDirective,
    ],
    exports: [
        EuiChipListComponent,
        EuiChipListAppendContentDirective,
    ],
    providers: [
        EuiChipListDragService,
    ],
})
export class EuiChipListModule { }
